export default __webpack_public_path__ + "static/media/Animals_26.17588a79.png";